import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vextroai.webp';
import screenshot_target from '../../../images/letterfunnel/quincyverkolf.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Quincy Verkolf"
      firstname="Quincy"
      companyname="Vextro.ai"
      competition="DataNorth en Xomnia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/quincyverkolf.js